import { Card } from 'react-bootstrap'
import styled from 'styled-components'

const CardBodyContainer = styled(Card.Body)`
	min-height: ${props => props.height}px;
	border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 16px;
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);

	background-color: var(--sub-bg-color);
`

CardBodyContainer.defaultProps = {
	height: 600,
}

export default CardBodyContainer
